import { createStyles } from "@mantine/emotion";

export const useStylesReports = createStyles((theme) => ({
  reports: {
    marginTop: theme.spacing.reports.margin.top,
    width: theme.spacing.reports.width.main,
    maxWidth: "100%",
  },
  reportsHeader: {
    maxWidth: "52.33em",
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      padding: "0 2.67em 0 2.80em",
    },
  },
  reportsTitle: {
    textAlign: "left",
    paddingBottom: "0.3em",
  },
  reportsText: {
    textAlign: "left",
    padding: "0",
    paddingBottom: "3em",
  },
  reportsBlock: {
    border: theme.customColors.tableBorder,
    backgroundColor: theme.customBackgrounds.white,
    padding: theme.spacing.reports.padding.block,
    position: "relative",
  },
  reportsBlockInner: {
    gap: theme.spacing.reports.gap.block,
  },
  reportsBlockWrap: {
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      flexWrap: "wrap",
    },
  },
  reportsBlockItem: {
    paddingTop: "0.6em",
  },
  reportsBlockTitle: {
    display: "block",
    fontSize: theme.spacing.reports.fontSize.title,
    fontWeight: "bold",
    fontFamily: theme.headings.fontFamily.secondary,
  },
  reportsBlockContentTitle: {
    fontSize: theme.spacing.reports.fontSize.content,
  },
  reportsBlockKey: {
    display: "block",
    color: theme.customColors.black,
    fontSize: theme.spacing.reports.fontSize.content,
    lineHeight: theme.spacing.reports.lineHeight.key,
    marginBottom: theme.spacing.reports.margin.bottom,
  },
  reportsBlockValue: {
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: theme.spacing.reports.fontSize.value,
    lineHeight: theme.spacing.reports.lineHeight.value,
    color: theme.customColors.black,
    marginRight: "0.45em",
  },
  reportsBlockContent: {
    position: "relative",
    width: theme.spacing.reports.width.content,
    height: theme.spacing.reports.height.content,
    padding: theme.spacing.reports.padding.content,
    b: {
      fontSize: theme.spacing.reports.fontSize.content,
      lineHeight: "1.22em",
      fontWeight: "normal",
    },
  },
  reportsBlockContentNumber: {
    position: "absolute",
    bottom: "0.83em",
    left: "0.67em",
    fontSize: "2em",
    lineHeight: "0.83em",
    fontFamily: theme.headings.fontFamily.bold,
  },
  reportsBlockContentTooltip: {
    position: "absolute",
    right: "0.5em",
    top: "0.5em",
  },

  reportsAvailableDownload: {
    textAlign: "right",
    marginTop: "1.33em",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      textAlign: "left",
    },
  },
  reportsAvailableDownloadProducer: {
    textAlign: "left",
    paddingBottom: "2em",
  },
  reportsAvailableDownloadTitle: {
    lineHeight: "1.47em",
    paddingBottom: "0.47em",
  },

  reportsAvailableDownloadContent: {
    justifyContent: "flex-end",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      justifyContent: "flex-start",
    },
  },
  reportsAvailableDownloadContentImg: {
    width: "1.93em",
    height: "1.93em",
    backgroundColor: theme.customBackgrounds.reportsDownload,
    borderRadius: "50%",
    marginRight: "0.53em",
    img: {
      width: "1em",
    },
  },
  reportsAvailableDownloadContentNo: {
    backgroundColor: theme.customBackgrounds.reportsDownloadNo,
  },
  reportsTableTitleWrap: {
    paddingBottom: "1em",
    paddingTop: "4em",
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      flexWrap: "wrap",
    },
  },
  reportsTableTitle: {
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: theme.spacing.reports.fontSize.value,
    lineHeight: "1.1em",
    fontWeight: "bold",
  },
  reportsTableLinks: {
    gap: theme.spacing.reports.gap.links,
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      marginTop: "0.5em",
    },
  },
}));
